(function($) {
	// $('body').switchView('criteria.editMenu');
	$.fn.switchView = function(view) {
		var group = '';
		if ( view.indexOf('.') > -1 ) {
			// We have a group also associated with this:
			var parts = view.split('.');
			group = Origin.ConvertCamelToDashed(parts[0]);
			view = parts[1];
		}
		
		var elements = [];
		if ( group == '' ) {
			$(this).find('[class*=view-on-]').each(function() {
				if ( !$(this).is('[class*=view-group-]') ) {
					if ( $(this).parents('[class*=view-group-]').length == 0 ) {
						elements.push( this );
					}
				}
			});
		} else {
			// There are two scenarios here
			// The first case is a view-group-{foo} view-on-{bar}
			// The second case is view-group-{foo} -> child view-on-{bar}
			$(this).find('.view-group-' + group).andSelf().filter('.view-group-' + group).each(function() {
				if ( $(this).is('[class*=view-on-]') ) {
					elements.push( this );
				} else {
					$(this).find('[class*=view-on-]').each(function() {
						elements.push( this );
					});
				}
			});
		}
		
		// TODO: Handle cases where we have multiple views
		view = Origin.ConvertCamelToDashed(view);
		var show = [];
		var reg = new RegExp('(^|\\s+)view-on-' + view + '(\\s+|$)');
		$(elements).filter(function() {
			return !( reg.test(this.className) && show.push(this) );
		})
		.addClass('view-hidden');
		$(show).removeClass('view-hidden');
		$(document).trigger('switchview', [ Origin.ConvertDashedToCamel(view), 'view-on-' + view, 
											Origin.ConvertDashedToCamel(group), ( group != '' ? 'view-group-' + group : '' ) ]);
		return this;
	};
	
	// Future additions
	$.fn.getViews = function() { };
	$.fn.isCurrentView = function(view) {
		
		view = Origin.ConvertCamelToDashed(view);

		var viewElement = $(this).find('.view-on-' + view);

		if (viewElement.length > 0) {
			
			if (viewElement.hasClass('view-hidden') || viewElement.is(':hidden') || viewElement.css('display') === 'none') {
				return false;
			}

			return true;
		}

		return false;
	};
	
	$.fn.currentView = function(view) { };
})(jQuery);